module.exports = __webpack_public_path__ + "img/pucko_logo_old.1ccfa70a.svg";